import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const DRAW_BASE_URL = `${environment.apiUrl2}/portal-draw`;
const APP_BASE_URL = `${environment.apiUrl2}/applications`;

@Injectable({
  providedIn: 'root',
})
export class PortalDrawService {
  private http: HttpClient = inject(HttpClient);

  getAllDraws(): Observable<{ data: any[] }> {
    return this.http.get<{ data: any[] }>(`${DRAW_BASE_URL}`);
  }

  getActivatedDraws(): Observable<any[]> {
    return this.http.get<any[]>(`${DRAW_BASE_URL}/activated`);
  }

  initializeDraw(draw: { examId: string; quantityOfApplications: number }): Observable<any> {
    return this.http.post<any>(`${APP_BASE_URL}/initialize-portal-draw`, draw);
  }

  initializeManualDraw(draw: { examId: string; applicationIds: string[] }): Observable<any> {
    return this.http.post<any>(`${APP_BASE_URL}/initialize-manual-portal-draw`, draw);
  }

  updateDraw(draw: { id: string; examId: string; quantityOfApplications: number }): Observable<any> {
    return this.http.put<any>(DRAW_BASE_URL, draw);
  }

  getSingleDrawByExamId(examId: string): Observable<any> {
    return this.http.get<any>(`${DRAW_BASE_URL}/exam/${examId}`);
  }

  getSingleDrawById(drawId: string): Observable<any> {
    return this.http.get<any>(`${DRAW_BASE_URL}/single/${drawId}`);
  }

  deleteDrawById(drawId: string): Observable<any> {
    return this.http.delete<any>(`${DRAW_BASE_URL}/single/${drawId}`);
  }
}
